import { Text } from '@actualtysoft/ui-kit';
import { useTheme } from '@mui/material';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardActionArea from '@mui/material/CardActionArea';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import CardMedia from '@mui/material/CardMedia';
import Grid from '@mui/material/Grid';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import akto from 'assets/images/akto.png';
import forhum from 'assets/images/forhum.png';
import ines from 'assets/images/ines.jpg';
import lucie from 'assets/images/lucie.png';
import { useUserStore } from 'stores/user';

const UserModal = (): JSX.Element => {
  const { user } = useUserStore();
  const theme = useTheme();

  return (
    <Box display="flex" height="100%" flexDirection="column">
      <Card elevation={0} variant="outlined">
        <CardHeader
          avatar={
            <Avatar
              aria-label="recipe"
              sx={{
                backgroundColor: theme.palette.error.main,
              }}
            >
              {user.initials}
            </Avatar>
          }
          title={user.fullName}
          subheader={user.job}
        />
        <CardContent>
          <List
            subheader={
              <Text
                sx={{
                  color: '#676767',
                  fontSize: '0.87rem',
                }}
              >
                Mes permissions
              </Text>
            }
            component="div"
            dense
          >
            {Array.from(new Set(user.permissions))
              .slice(0, 20)
              .map((permission, index) => (
                <ListItem key={index}>{permission}</ListItem>
              ))}
          </List>
        </CardContent>
      </Card>
      <Text my={2} variant="h4">
        Liens rapides
      </Text>
      <Grid container spacing={2}>
        {[
          {
            title: 'Forhum',
            href: 'https://groupeactual.app.lumapps.com/home',
            image: forhum,
          },
          {
            title: 'Lucie',
            href:
              process.env.VITE_APP_BUILD_ENV === 'prod'
                ? 'https://www.groupeactual.eu/lucie'
                : 'https://eactual-preprod.groupeactual.eu/lucie',
            image: lucie,
          },
          { title: 'Ines', href: 'https://extend.inescrm.com', image: ines },
          { title: 'Akto', href: 'https://www.akto.fr', image: akto },
        ].map((item, index) => (
          <Grid size={{ xs: 6, sm: 3 }} key={index}>
            <Card
              sx={{
                transition: 'transform 0.3s',
                '&:hover': { transform: 'scale(1.05)' },
              }}
            >
              <CardActionArea
                onClick={() =>
                  window.open(item.href, '_blank', 'noopener,noreferrer')
                }
              >
                <CardMedia
                  component="img"
                  sx={{
                    objectFit: 'contain',
                    display: 'block',
                    margin: 'auto',
                    maxHeight: 50,
                    width: 'auto',
                    p: 1,
                  }}
                  image={item.image}
                  alt={item.title}
                />
                <CardContent sx={{ p: 1 }}>
                  <Text variant="body2" align="center">
                    {item.title}
                  </Text>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default UserModal;
